import {Component, Inject, OnInit} from '@angular/core';
import {ApiService} from "../../api.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material";
import {MasseComponent} from "../masse.component";
import * as moment from "moment";
import {SelectionModel} from "@angular/cdk/collections";
import {BaseComponent} from "../../BaseComponent";

@Component({
  selector: 'app-collaborators',
  templateUrl: './collaborators.component.html',
  styleUrls: ['./collaborators.component.css']
})
export class CollaboratorsComponent extends BaseComponent implements OnInit {
  users: Array<any> = [];
  selection= new SelectionModel<any>(true, []);
  constructor(private api: ApiService, public dialogRef: MatDialogRef<MasseComponent>,
              @Inject(MAT_DIALOG_DATA) public injectData: {date: any, usersSelected: Array<string>}) {
    super();
  }

  ngOnInit() {
    const {date, usersSelected} = this.injectData;
    console.log({date, usersSelected})
    this.api.getHierarchyUsers().subscribe((res: any) => {
      if(!this.api.userHierarchy.length)
      this.api.userHierarchy = res.map(e => e.teams.map(e => e.users).flat()).flat();

      this.users = this.api.userHierarchy;
      this.users = !this.users.length ? mocks: this.users;

      this.users = this.users.map((user) => {
        let isInPeriods = this.InPeriods(date, user.periods)

        if(user.username == "mstansby0") {
          console.log("isInPeriods:", {isInPeriods, periods : user.periods, date: date.format("YYYY-MM-DD")})
        }
        user.hasEnabled = isInPeriods;
        return user;
      }).filter((user) => !usersSelected.includes(user.username));
    })
  }
  selectionUser(user) {
    if(user.hasEnabled) {
      if(this.selection.isSelected(user)) {
        this.selection.deselect(user)
      } else {
        this.selection.select(user)
      }
    }
  }
  save(action: "SAVE" | "CANCEL") {
    this.dialogRef.close(action == "SAVE" ? this.selection.selected : null)
  }
}
const mocks = [{
  "id": 1,
  "firstName": "Marylynne",
  "lastName": "Stansby",
  "username": "mstansby0",
  "periods": [
    {
      "start": "2023-05-01",
      "end": "2023-05-03"
    }
  ]
}, {
  "id": 2,
  "firstName": "Patsy",
  "lastName": "Foystone",
  "username": "pfoystone1",
  "periods": [
    {
      "start": "2023-05-04",
      "end": null
    }
  ]
}, {
  "id": 3,
  "firstName": "Kile",
  "lastName": "May",
  "username": "kmay2",
  "periods": [
    {
      "start": "2023-05-04",
      "end": null
    }
  ]
}, {
  "id": 4,
  "firstName": "Aimee",
  "lastName": "Barns",
  "username": "abarns3",
  "periods": [
    {
      "start": "2023-05-04",
      "end": null
    }
  ]
}, {
  "id": 5,
  "firstName": "Krissy",
  "lastName": "Pittford",
  "username": "kpittford4",
  "periods": [
    {
      "start": "2023-05-04",
      "end": null
    }
  ]
}, {
  "id": 6,
  "firstName": "Jacques",
  "lastName": "Brende",
  "username": "jbrende5",
  "periods": [
    {
      "start": "2023-05-04",
      "end": null
    }
  ]
}, {
  "id": 7,
  "firstName": "Simone",
  "lastName": "Pusey",
  "username": "spusey6",
  "periods": [
    {
      "start": "2023-05-04",
      "end": null
    }
  ]
}, {
  "id": 8,
  "firstName": "Juanita",
  "lastName": "Peck",
  "username": "jpeck7",
  "periods": [
    {
      "start": "2023-05-04",
      "end": null
    }
  ]
}, {
  "id": 9,
  "firstName": "Ragnar",
  "lastName": "Delacroix",
  "username": "rdelacroix8",
  "periods": [
    {
      "start": "2023-05-04",
      "end": null
    }
  ]
}, {
  "id": 10,
  "firstName": "Susan",
  "lastName": "Rosen",
  "username": "srosen9",
  "periods": [
    {
      "start": "2023-05-04",
      "end": null
    }
  ]
}, {
  "id": 11,
  "firstName": "Falkner",
  "lastName": "Rakes",
  "username": "frakesa",
  "periods": [
    {
      "start": "2023-05-04",
      "end": null
    }
  ]
}, {
  "id": 12,
  "firstName": "Alyda",
  "lastName": "Slym",
  "username": "aslymb",
  "periods": [
    {
      "start": "2023-05-04",
      "end": null
    }
  ]
}, {
  "id": 13,
  "firstName": "Christalle",
  "lastName": "Bramford",
  "username": "cbramfordc",
  "periods": [
    {
      "start": "2023-05-04",
      "end": null
    }
  ]
}, {
  "id": 14,
  "firstName": "Araldo",
  "lastName": "Ritchley",
  "username": "aritchleyd",
  "periods": [
    {
      "start": "2023-05-04",
      "end": null
    }
  ]
}, {
  "id": 15,
  "firstName": "Hilario",
  "lastName": "Daulby",
  "username": "hdaulbye",
  "periods": [
    {
      "start": "2023-05-04",
      "end": null
    }
  ]
}, {
  "id": 16,
  "firstName": "Aeriell",
  "lastName": "Coppard",
  "username": "acoppardf",
  "periods": [
    {
      "start": "2023-05-04",
      "end": null
    }
  ]
}, {
  "id": 17,
  "firstName": "Verla",
  "lastName": "Waltho",
  "username": "vwalthog",
  "periods": [
    {
      "start": "2023-05-04",
      "end": null
    }
  ]
}, {
  "id": 18,
  "firstName": "Aubrie",
  "lastName": "Strangman",
  "username": "astrangmanh",
  "periods": [
    {
      "start": "2023-05-04",
      "end": null
    }
  ]
}, {
  "id": 19,
  "firstName": "Chandra",
  "lastName": "Arcase",
  "username": "carcasei",
  "periods": [
    {
      "start": "2023-05-04",
      "end": null
    }
  ]
}, {
  "id": 20,
  "firstName": "Aggy",
  "lastName": "Stienham",
  "username": "astienhamj",
  "periods": [
    {
      "start": "2023-05-04",
      "end": null
    }
  ]
}, {
  "id": 21,
  "firstName": "Erie",
  "lastName": "Arrighi",
  "username": "earrighik",
  "periods": [
    {
      "start": "2023-05-04",
      "end": null
    }
  ]
}, {
  "id": 22,
  "firstName": "Berri",
  "lastName": "Oldacres",
  "username": "boldacresl",
  "periods": [
    {
      "start": "2023-05-04",
      "end": null
    }
  ]
}, {
  "id": 23,
  "firstName": "Felipa",
  "lastName": "Abatelli",
  "username": "fabatellim",
  "periods": [
    {
      "start": "2023-05-04",
      "end": null
    }
  ]
}, {
  "id": 24,
  "firstName": "Chiquita",
  "lastName": "Thackeray",
  "username": "cthackerayn",
  "periods": [
    {
      "start": "2023-05-04",
      "end": null
    }
  ]
}, {
  "id": 25,
  "firstName": "Joletta",
  "lastName": "Cominetti",
  "username": "jcominettio",
  "periods": [
    {
      "start": "2023-05-04",
      "end": null
    }
  ]
}, {
  "id": 26,
  "firstName": "Nikolia",
  "lastName": "Alejo",
  "username": "nalejop",
  "periods": [
    {
      "start": "2023-05-04",
      "end": null
    }
  ]
}, {
  "id": 27,
  "firstName": "Haley",
  "lastName": "McCuaig",
  "username": "hmccuaigq",
  "periods": [
    {
      "start": "2023-05-04",
      "end": null
    }
  ]
}, {
  "id": 28,
  "firstName": "Hildagarde",
  "lastName": "Semrad",
  "username": "hsemradr",
  "periods": [
    {
      "start": "2023-05-04",
      "end": null
    }
  ]
}, {
  "id": 29,
  "firstName": "Devlin",
  "lastName": "Ottawell",
  "username": "dottawells",
  "periods": [
    {
      "start": "2023-05-04",
      "end": null
    }
  ]
}, {
  "id": 30,
  "firstName": "Chickie",
  "lastName": "Lampard",
  "username": "clampardt",
  "periods": [
    {
      "start": "2023-05-04",
      "end": null
    }
  ]
}]



// WEBPACK FOOTER //
// ./src/app/modules/injection/masse/collaborators/collaborators.component.ts